/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDeleteEmptyCategoriesResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListEmptyCategoriesResponseFromDiscriminatorValue, type DeleteEmptyCategoriesResponse, type ErrorResponse, type InternalErrorResponse, type ListEmptyCategoriesResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/categories/empty
 */
export interface EmptyRequestBuilder extends BaseRequestBuilder<EmptyRequestBuilder> {
    /**
     * Removes every category no active product sits in, directly or anywhere below it, along with each removed category's uploaded image. A category holding only empty subcategories goes with them, so an abandoned branch is cleared whole; one stocked descendant keeps the entire chain above it. Inactive products don't count as occupants, so a category holding nothing but inactive products is removed. The set is resolved at deletion time rather than taken from the caller, so a category a product moved into since the last preview is left alone. Removing nothing is a success, not an error.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DeleteEmptyCategoriesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DeleteEmptyCategoriesResponse | undefined>;
    /**
     * Lists the categories no active product sits in, directly or anywhere below them - the exact set DELETE api/categories/empty would remove. A category holding only empty subcategories is itself empty and appears alongside them, so an abandoned branch is listed whole. Inactive products don't count as occupants: a category holding nothing but inactive products is listed, since they appear in no catalog.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListEmptyCategoriesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListEmptyCategoriesResponse | undefined>;
    /**
     * Removes every category no active product sits in, directly or anywhere below it, along with each removed category's uploaded image. A category holding only empty subcategories goes with them, so an abandoned branch is cleared whole; one stocked descendant keeps the entire chain above it. Inactive products don't count as occupants, so a category holding nothing but inactive products is removed. The set is resolved at deletion time rather than taken from the caller, so a category a product moved into since the last preview is left alone. Removing nothing is a success, not an error.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Lists the categories no active product sits in, directly or anywhere below them - the exact set DELETE api/categories/empty would remove. A category holding only empty subcategories is itself empty and appears alongside them, so an abandoned branch is listed whole. Inactive products don't count as occupants: a category holding nothing but inactive products is listed, since they appear in no catalog.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const EmptyRequestBuilderUriTemplate = "{+baseurl}/api/categories/empty";
/**
 * Metadata for all the requests in the request builder.
 */
export const EmptyRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: EmptyRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDeleteEmptyCategoriesResponseFromDiscriminatorValue,
    },
    get: {
        uriTemplate: EmptyRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListEmptyCategoriesResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
